var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 30,
    viewBox: "0 0 59 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.29016e-06 24C-3.57985e-06 27.3137 2.68629 30 6 30L53 30C56.3137 30 59 27.3137 59 24L59 9.99998C59 6.68627 56.3137 3.99998 53 3.99998L33.1097 3.99997C31.4794 3.99997 29.9193 3.33655 28.7883 2.16234C27.7191 1.05228 26.4057 2.87257e-06 24.8645 2.73783e-06L6 1.08864e-06C2.68629 7.98945e-07 -1.42686e-06 2.68629 -1.71655e-06 6L-3.29016e-06 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMini);
export default __webpack_public_path__ + "static/media/folder-mini.034d81d0a24a14e4f01b3e45ab47c6dc.svg";
export { ForwardRef as ReactComponent };